import { Box, Typography, Divider } from "@mui/material";

const VendorComplianceReports = () => {
  return (
    <Box>
      <Box p={2}>
        <Typography variant="h4" m={2}>
          Compliance Reports
        </Typography>
      </Box>
      <Divider />
    </Box>
  );
};

export default VendorComplianceReports;
